var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1080 1080",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #1f3060;\n      }\n\n      .cls-2 {\n        fill: #fff;\n      }\n\n      .cls-3 {\n        fill: #ccc;\n      }\n\n      .cls-4 {\n        fill: #fbfcfc;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_20._Tax"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 524.9,
    cy: 560.7,
    r: 469.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M933.47,288.32v502.99c-120.1,212.81-383.46,297.78-605.28,195.28V167.26h484.23l121.06,121.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M842.68,424.51h-423.7c-8.36,0-15.13-6.77-15.13-15.13s6.77-15.13,15.13-15.13h423.7c8.36,0,15.13,6.77,15.13,15.13s-6.77,15.13-15.13,15.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M842.68,515.3h-423.7c-8.36,0-15.13-6.77-15.13-15.13s6.77-15.13,15.13-15.13h423.7c8.36,0,15.13,6.77,15.13,15.13s-6.77,15.13-15.13,15.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M842.68,606.1h-423.7c-8.36,0-15.13-6.77-15.13-15.13s6.77-15.13,15.13-15.13h423.7c8.36,0,15.13,6.77,15.13,15.13s-6.77,15.13-15.13,15.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M842.68,696.89h-423.7c-8.36,0-15.13-6.77-15.13-15.13s6.77-15.13,15.13-15.13h423.7c8.36,0,15.13,6.77,15.13,15.13s-6.77,15.13-15.13,15.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M842.68,787.68h-423.7c-8.36,0-15.13-6.77-15.13-15.13s6.77-15.13,15.13-15.13h423.7c8.36,0,15.13,6.77,15.13,15.13s-6.77,15.13-15.13,15.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M842.68,878.47h-423.7c-8.36,0-15.13-6.77-15.13-15.13s6.77-15.13,15.13-15.13h423.7c8.36,0,15.13,6.77,15.13,15.13s-6.77,15.13-15.13,15.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M555.17,530.44v498.38c-169.29,10.96-331.3-70.34-423.7-212.61v-285.77c0-25.07,20.32-45.4,45.4-45.4h332.91c25.07,0,45.4,20.32,45.4,45.4h0Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 313.05,
    cy: 227.79,
    r: 166.45
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 192,
    y: 545.57,
    width: 302.64,
    height: 121.06,
    rx: 15.13,
    ry: 15.13
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 207.13,
    y: 712.02,
    width: 60.53,
    height: 60.53,
    rx: 7.57,
    ry: 7.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 313.05,
    y: 712.02,
    width: 60.53,
    height: 60.53,
    rx: 7.57,
    ry: 7.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 418.98,
    y: 712.02,
    width: 60.53,
    height: 60.53,
    rx: 7.57,
    ry: 7.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 207.13,
    y: 817.95,
    width: 60.53,
    height: 60.53,
    rx: 7.57,
    ry: 7.57
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M267.66,931.44v21.49c-13.73-8.96-26.97-18.66-39.65-29.05h32.08c4.18,0,7.57,3.39,7.57,7.57Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 313.05,
    y: 817.95,
    width: 60.53,
    height: 60.53,
    rx: 7.57,
    ry: 7.57
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M373.58,931.44v45.4c0,4.18-3.39,7.57-7.57,7.57h-42.37c-3.4-1.51-6.73-3.18-10.06-4.92-.76-1.66-.53,1.29-.53-48.04,0-4.18,3.39-7.57,7.57-7.57h45.4c4.18,0,7.57,3.39,7.57,7.57Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 418.98,
    y: 817.95,
    width: 60.53,
    height: 60.53,
    rx: 7.57,
    ry: 7.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 418.98,
    y: 923.87,
    width: 60.53,
    height: 60.53,
    rx: 7.57,
    ry: 7.57
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M933.47,288.32h-90.79c-16.71,0-30.26-13.55-30.26-30.26v-90.79l121.06,121.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M237.39,318.59c-8.36-.04-15.1-6.84-15.07-15.2.02-3.98,1.6-7.79,4.4-10.6l151.32-151.32c6.35-5.44,15.9-4.7,21.34,1.65,4.85,5.67,4.85,14.02,0,19.69l-151.32,151.32c-2.82,2.84-6.66,4.45-10.67,4.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M252.53,212.66c-25.07,0-45.4-20.32-45.4-45.4s20.32-45.4,45.4-45.4,45.4,20.32,45.4,45.4-20.32,45.4-45.4,45.4ZM252.53,152.13c-8.36,0-15.13,6.77-15.13,15.13s6.77,15.13,15.13,15.13,15.13-6.77,15.13-15.13-6.77-15.13-15.13-15.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M373.58,333.72c-25.07,0-45.4-20.32-45.4-45.4s20.32-45.4,45.4-45.4,45.4,20.32,45.4,45.4-20.32,45.4-45.4,45.4ZM373.58,273.19c-8.36,0-15.13,6.77-15.13,15.13s6.77,15.13,15.13,15.13,15.13-6.77,15.13-15.13-6.77-15.13-15.13-15.13Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 139.04,
    cy: 961.7,
    r: 22.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 910.77,
    cy: 189.96,
    r: 22.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 880.51,
    cy: 961.7,
    r: 22.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 169.3,
    cy: 386.68,
    r: 22.7
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFive);
export default __webpack_public_path__ + "static/media/five.d174a4de689f51a9f9553f87d2c617d5.svg";
export { ForwardRef as ReactComponent };